import { Plus } from 'react-feather';
import { CircularProgress } from '@material-ui/core';
import datetimeProvider from '../../../providers/datetime.provider';

const contactTypeLabels = {
  customer: 'Clientes',
  lead: 'Leads',
  faciliter: 'Faciliters',
};

const SegmentationSummary = ({
  segmentationConfig = { included: [] },
  contactType = 'customer',
  availableTags = [],
  contactsCount = null,
  loading = false,
  title = 'Segmentação',
}) => {
  const moment = datetimeProvider.momentInstance();
  const safeTags = Array.isArray(availableTags) ? availableTags : [];
  const included = segmentationConfig?.included || [];
  const hasSegmentation = included.length;

  const getTagById = (id) => safeTags.find((t) => (t.id || t.segmentationTagId || t.value) === id);

  const formatFilterValue = (filterDef, value) => {
    if (value === null || value === undefined || value === '') return null;

    const valArray = Array.isArray(value) ? value : [value];
    const type = filterDef?.type || filterDef?.inputType || filterDef?.key;

    const formatDate = (val) => {
      const parsed = moment(val);
      return parsed.isValid() ? parsed.format('DD/MM/YYYY') : val;
    };

    if (type === 'period' && valArray.length) {
      const [start, end] = valArray;
      if (start && end) return `${formatDate(start)} a ${formatDate(end)}`;
      if (start) return formatDate(start);
      if (end) return formatDate(end);
    }

    if (type === 'date' && valArray[0]) return formatDate(valArray[0]);

    if ((filterDef?.options || []).length) {
      const option = filterDef.options.find((opt) => (opt.id || opt.value)?.toString() === valArray[0]?.toString());
      if (option?.label || option?.name) return option.label || option.name;
    }

    if (valArray.length > 1) return valArray.join(', ');

    if (filterDef?.suffix) return `${valArray[0]} ${filterDef.suffix}`;

    return valArray[0];
  };

  const renderFilters = (tag, filters = []) => {
    if (!filters.length) return null;
    const filterDefs = tag?.filters || tag?.filterFields || [];

    return (
      <div className="ml-6 mt-2 space-y-2">
        {filters.map((filter) => {
          const def = filterDefs.find((fd) => (fd.id || fd.segmentationFilterFieldId) === filter.segmentationFilterFieldId);
          const label = def?.label || def?.name;
          const formattedValue = formatFilterValue(def, filter.value);
          if (!formattedValue || !label) return null;
          return (
            <p key={filter.segmentationFilterFieldId} className="text-xs text-gray-600 leading-relaxed">
              {label}: {formattedValue}
            </p>
          );
        })}
      </div>
    );
  };

  const renderSegmentationSection = (items = []) => {
    if (!items.length) return null;
    return (
      <div className="space-y-3 pt-3 border-t border-gray-200">
        <span className="text-xs uppercase tracking-wide text-gray-500">Incluir</span>
        <div className="space-y-3">
          {items.map((item) => {
            const tag = getTagById(item.segmentationTagId);
            const tagName = tag?.name || tag?.label || `Tag #${item.segmentationTagId}`;
            const hasFilters = (item.filters || []).some((f) => f.value !== null && f.value !== undefined && f.value !== '');
            return (
              <div key={item.segmentationTagId} className="space-y-2">
                <div className="flex items-center gap-2">
                  <Plus className="h-3 w-3 text-gray-500 flex-shrink-0" />
                  <span className="font-medium text-gray-900 text-sm">{tagName}</span>
                </div>
                {hasFilters && renderFilters(tag, item.filters)}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-3 text-sm text-gray-900">
      <div className="flex items-center justify-between">
        <span className="text-base font-medium text-gray-900">{title}</span>
        {loading && <CircularProgress size={16} />}
      </div>

      <div className="flex items-center justify-between text-sm">
        <span className="text-gray-600">Tipo de contato</span>
        <span className="font-medium text-gray-900">{contactTypeLabels[contactType] || contactTypeLabels.customer}</span>
      </div>

      {renderSegmentationSection(included)}

      {!hasSegmentation && !loading && (
        <div className="text-sm text-gray-600 py-2 border-t border-gray-200 mt-1">Nenhuma segmentação selecionada</div>
      )}

      {contactsCount !== null && contactsCount !== undefined && (
        <div className="pt-3 mt-2 border-t border-gray-200 flex items-center justify-between">
          <span className="text-base text-gray-700">Total estimado</span>
          <span className="text-base text-gray-900">{Number(contactsCount).toLocaleString('pt-BR')}</span>
        </div>
      )}
    </div>
  );
};

export default SegmentationSummary;
